import qs from 'qs';
import {Location, History} from "history";

/**
 * Reads specific query parameter from the given location object.
 *
 * @param {Location} location the location object to read from
 * @param {string} param - the query param to read
 * @returns {QueryString.PoorMansUnknown}
 */
export function getQueryParam(location: Location, param: string) {
  return qs.parse(location.search, {ignoreQueryPrefix: true})[param];
}

export function reloadOrRedirect(history: History, targetUrl: string, nextUrl: string) {
  // Do this url switch only when current url is the same as where the link is supposed to lead.
  // The reason for this trick is that otherwise the router prevents reloading the same route.
  if (history.location.pathname === targetUrl) {
    history.replace(`/reload`);
    setTimeout(() => {
      history.replace(nextUrl);
    });
  } else {
    history.push(nextUrl);
  }
}

/**
 * Returns the current URL but without any query params or fragments.
 *
 * @returns {string} clean URL string
 */
export function getCleanUrl() {
  return `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
}
